<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="50%"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Row :gutter="32">
                <Col span="24">
                    <DescriptionList class="show-description-title" title="" :col="4"  layout="vertical">
                        <Description term="编号：">
                            {{detail.sn}}
                        </Description>
                        <Description term="状态：">
                            <Badge v-if="detail.status === 1" color="blue" :text="detail.status_name" />
                            <Badge v-else-if="detail.status === 2" color="orange" :text="detail.status_name" />
                            <Badge v-else-if="detail.status === 3" color="red" :text="detail.status_name" />
                            <Badge v-else-if="detail.status === 4" color="green" :text="detail.status_name" />
                            <Badge v-else color="#999999" text="其他" />
                        </Description>
                        <Description term="零星项目：">
                            {{detail.project_name}}
                        </Description>
                        <Description term="甲方：">
                            {{detail.customer_name ?? '-'}}
                        </Description>
                        <Description term="维保记录：">
                            {{detail.maintain_title ?? '-'}}
                        </Description>
                        <Description term="收款类型：">
                            <Tag>{{detail.type_name}}</Tag>
                        </Description>
                        <Description term="不含税金额：">
                            <Tag color="blue">{{detail.money}}</Tag>
                        </Description>
                        <Description term="费率：">
                            <Tag>{{detail.tax_rate}} %</Tag>
                        </Description>
                        <Description term="税费：">
                            <Tag>{{detail.tax_money}}</Tag>
                        </Description>
                        <Description term="含税金额：">
                            <Tag color="green">{{detail.true_money}}</Tag>
                        </Description>
                        <Description term="发票状态：">
                            <Badge v-if="detail.is_invoice === 1" color="#999999" :text="detail.is_invoice_name" />
                            <Badge v-else-if="detail.is_invoice === 2" color="orange" :text="detail.is_invoice_name" />
                            <Badge v-else-if="detail.is_invoice === 3" color="blue" :text="detail.is_invoice_name" />
                            <Badge v-else-if="detail.is_invoice === 4" color="green" :text="detail.is_invoice_name" />
                            <Badge v-else color="#999999" text="-" />
                        </Description>
                        <Description term="已开票金额：" v-if="detail.is_invoice === 3 || detail.is_invoice === 4">
                            <Tag color="green">{{detail.use_inv_money}}</Tag>
                        </Description>
                        <Description term="申请人：">
                            {{detail.apply_name}}
                        </Description>
                        <Description term="申请时间：">
                            {{detail.apply_time}}
                        </Description>
                        <Description term="到账金额：" v-if="detail.status === 4">
                            <Tag color="green">{{detail.get_money}}</Tag>
                        </Description>
                        <Description term="到账时间：" v-if="detail.status === 4">
                            {{detail.get_date}}
                        </Description>
                        <Description term="到账凭证：" v-if="detail.status === 4 && detail.get_voucher">
                            <a href="javascript:void(0);" @click="FileDownload(detail.get_voucher)">下载文件</a>
                        </Description>
                        <Description term="驳回原因：" v-if="detail.status === 3">
                            <span class="text-danger">{{detail.reject_remark}}</span>
                        </Description>
                        <Description term="驳回时间：" v-if="detail.status === 3">
                            {{detail.reject_time}}
                        </Description>
                        <Description term="审核人：" v-if="detail.auditor_name">
                            {{detail.auditor_name}}
                        </Description>
                    </DescriptionList>
                    <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                        <Description term="发票抬头：">
                            {{detail.invoice_head ?? '-'}}
                        </Description>
                        <Description term="发票税号：">
                            {{detail.invoice_tax ?? '-'}}
                        </Description>
                        <Description term="发票电话：">
                            {{detail.invoice_phone ?? '-'}}
                        </Description>
                        <Description term="发票地址：">
                            {{detail.invoice_address ?? '-'}}
                        </Description>
                        <Description term="开户银行：">
                            {{detail.bank_name ?? '-'}}
                        </Description>
                        <Description term="银行卡号：">
                            {{detail.bank_card ?? '-'}}
                        </Description>
                    </DescriptionList>
                    <Row v-if="detail.invoice_list && detail.invoice_list.length > 0" class="inv-list-box">
                        <Col span="24">
                            <div class="inv-list-title">发票信息（{{detail.invoice_list.length}}）</div>
                            <table class="inv-table">
                                <thead>
                                    <tr>
                                        <th>发票编号</th>
                                        <th>发票类型</th>
                                        <th>开票公司</th>
                                        <th>开票金额</th>
                                        <th>状态</th>
                                        <th>发票附件</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in detail.invoice_list" :key="item.invoice_id">
                                        <td>{{item.sn}}</td>
                                        <td>{{item.inv_type_name}}</td>
                                        <td>{{item.inv_company_name || '-'}}</td>
                                        <td>{{item.inv_money}}</td>
                                        <td>
                                            <Badge v-if="item.status === 3" color="green" :text="item.status_name" />
                                            <Badge v-else-if="item.status === 2" color="red" :text="item.status_name" />
                                            <Badge v-else color="blue" :text="item.status_name" />
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" v-if="item.invoice_image" @click="FileDownload(item.invoice_image)">下载文件</a>
                                            <span v-else>-</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical" v-if="detail.remark">
                        <Description term="备注信息：">
                            {{detail.remark}}
                        </Description>
                    </DescriptionList>
                </Col>
            </Row>
        </div>
    </Drawer>
</template>

<script>

import {getDispersedIncomeDetail} from "@/apis/dispersed";

export default {
    name: 'DispersedIncomeShow',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '收款详情',
            isBox : false,
            site_url : this.$siteApi,
            detail: []
        }
    },
    methods: {

        /**
         功能：文件下载
         time: 2026/09/12
         **/
        FileDownload(url){
            let that = this;
            if(url){
                //下载文件
                const fileUrl = that.site_url + url; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },

        /**
         功能：详情
         time: 2026/09/12
         **/
        GetDetail(income_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getDispersedIncomeDetail(income_id).then(e => {
                that.detail = e.data;
            })
        },
        /**
         功能：打开
         time: 2026/09/12
         **/
        show(income_id){
            this.isBox = true;
            if(income_id) this.GetDetail(income_id);
        },
        /**
         功能：重置
         time: 2026/09/12
         **/
        FormReset(){
            this.isBox = false;
            this.title = '收款详情';
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.inv-list-box{
    margin-top: 8px;
}
.inv-list-title{
    font-weight: 600;
    margin-bottom: 10px;
    padding-left: 8px;
    border-left: 3px solid #2d8cf0;
}
.inv-table{
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    th, td{
        border: 1px solid #e8eaec;
        padding: 8px 10px;
        text-align: left;
    }
    th{
        background: #f8f8f9;
        color: #515a6e;
        font-weight: 600;
    }
}
</style>
